<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="ok()"></div>
        <div class="bottomDrawer white_bg" style="height: 528px; border-radius: 0;">
            <div class="body">
                <div class="flexLayout hiddenScrollbar" style="height: 446px; overflow: auto">
                    <div class="hiddenScrollbar" style="width: 86px; height: 100%; overflow: auto;
                        background: #F2F3F8;"><!-- 省份栏 -->
                        <div class="areaItem" :class="{active : selectedProvince == provinceName}"
                             v-for="(provinceItem, provinceName, i) in cities_v2" :key="i"
                             @click="selectedProvince=provinceName; cityList=provinceItem;
                                selectedCity=null; selectedAreaList=[];">
                            {{provinceName}}
                        </div>
                    </div>
                    <div class="flexItem" style="height: 100%;">
                        <div class="flexLayout" style="height: 100%;">
                            <div class="hiddenScrollbar" style="width: 96px; height: 100%; overflow: auto;">
                                <div class="areaItem" :class="{active : selectedCity == cityName}"
                                     v-for="(cityItem, cityName, i) in cityList" :key="i"
                                     @click="selectedCity=cityName; areaList=cityItem; selectedAreaList=[];">
                                    {{cityName}}
                                </div>
                            </div><!-- 城市栏 -->
                            <div class="flexItem" style="height: 100%;">
                                <div class="color333" style="padding-top: 12px; padding-bottom: 26px;">
                                    <span class="bold" v-if="selectedProvince">{{selectedProvince}}</span>
                                    <span class="bold" v-if="selectedCity">/{{selectedCity}}</span>
                                    <span class="font10r" style="color: #FF4D48; margin-left: 8px;">可多选</span>
                                </div>
                                <div style="height: 100%;">
                                    <span class="areaTag" v-for="(areaItem, i) in areaList" :key="i"
                                      :class="{active : dataMixedUtils.array.existElement(areaItem, selectedAreaList)}"
                                        @click="selectArea(areaItem)">
                                        {{areaItem}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="operationArea" style="height: 48px; padding-bottom: 34px;">
                    <div class="generalPagePaddingH" style="padding-top: 6px">
                        <div class="flexLayout">
                            <div style="width: 122px">
                                <button class="button block clearButton" @click="clear()">清除</button>
                            </div>
                            <div class="flexItem marginL8">
                                <button class="button block okButton" @click="ok()">确定</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '../part/drawerPart';

// data
import cities_v2 from '@data/cities_v2_short_name.json';

// util
import dataMixedUtils from '@util/dataMixedUtils';

// config
const config = {
    apiConfig : {
        list : {
            url : "",
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        },
        get : {
            url : '',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: "areaSelectorDrawer",
    extends : drawerPart,
    data() {
        return {
            apiConfig : config.apiConfig,
            cities_v2 : cities_v2,
            selectedProvince : null,
            cityList : [],
            selectedCity : null,
            areaList : [],
            selectedAreaList : [],

            dataMixedUtils : dataMixedUtils
        }
    },
    methods : {
        selectArea(areaItem) {

            if (dataMixedUtils.array.existElement(areaItem, this.selectedAreaList))
            {
                this.selectedAreaList = dataMixedUtils.array.removeElement(this.selectedAreaList, areaItem);
            }
            else
            {
                this.selectedAreaList.push(areaItem);
            }
        },
        clear() {
            this.selectedAreaList = [];
            this.areaList = []
            this.selectedCity = null;
            this.cityList = null;
            this.selectedProvince = null;
        },
        ok() {
            this.$emit('change', {
                province : this.selectedProvince,
                city : this.selectedCity,
                areaList : this.selectedAreaList,
            });
            this.close();
        }
    }
}
</script>

<style lang="scss" scoped>

.areaItem {
    line-height: 40px;
    color: #333;
    font-weight: bolder;
    margin-bottom: 8px;
    text-align: center;

    &.active {
        background: #FFFFFF;
        color: #FFA724
    }
}
.areaTag {
    display: inline-block;
    //width: 68px;
    height: 26px;
    line-height: 26px;
    //padding: 0 20px;
    padding: 0 14px;
    background: #F2F3F8;
    border-radius: 4px;
    text-align: center;
    color: #5B616C;
    font-size: 14px;
    margin-right: 8px;
    margin-bottom: 16px;

    &.active {
        background: #FFC439;
        color: white;
    }
}
.operationArea {
    .button {
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        font-size: 14px;
    }
    .clearButton {
        background: #F2F3F8;
        color: #333;
    }
    .okButton {
        background: #FFA724;
        color: white;
    }

}
</style>
